const EventEmitter = require('events');

class AuthHandler extends EventEmitter {
  private _token;
  private _redirectLocation;

  static readonly events = {
    TOKEN_UPDATED: 'TOKEN_UPDATED',
    AUTHENTICATED: 'AUTHENTICATED',
    UNAUTHENTICATED: 'UNAUTHENTICATED',
    REDIRECTION: 'REDIRECTION'
  };

  constructor() {
    super();
  }

  set redirectLocation(loc) {
    this._redirectLocation = loc;
    if (loc) {
      this.emit(AuthHandler.events.REDIRECTION, loc);
    }
  }

  get redirectionLocation() {
    return this._redirectLocation;
  }

  set token(token) {
    if (token === this._token) {
      //
    } else if (!token) {
      this._token = token;
      this.emit(AuthHandler.events.UNAUTHENTICATED);
    } else {
      this._token = token;
      if (!this._token) {
        this.emit(AuthHandler.events.AUTHENTICATED, this._token);
      } else {
        this.emit(AuthHandler.events.TOKEN_UPDATED, this._token);
      }
    }
  }

  get token() {
    return this._token;
  }
}

export { AuthHandler };
